import { CircleDotIcon, ListIcon, TypeIcon } from "lucide-react";
import type { MatrixColumnType } from "@/domains/matrix";

export const COLUMN_TYPE_ICONS: Record<MatrixColumnType, typeof TypeIcon> = {
  text: TypeIcon,
  badge: CircleDotIcon,
  list: ListIcon,
};

export const COLUMN_TYPE_LABELS: Record<MatrixColumnType, string> = {
  text: "Text",
  badge: "Badge",
  list: "List",
};

// The separator is its own field, so a surface can render it as a keycap.
export const COLUMN_TYPE_INPUT_HINTS: Record<
  MatrixColumnType,
  { hint: string; separator?: string }
> = {
  text: { hint: "Free text, Markdown supported." },
  badge: { hint: "Short labels, separated by", separator: "," },
  list: { hint: "List items, separated by", separator: "," },
};
